import {User} from '..';
import {Action} from '@ngrx/store';
import {type} from '../utilities/type';

export const usersActionTypes = {
  LOAD: type('[Users] Load'),
  LOAD_SUCCESS: type('[Users] Load Success'),
  LOAD_FAIL: type('[ Users] Load Fail'),

};

export class LoadUsersAction implements Action {
  readonly type = usersActionTypes.LOAD;
  constructor() {}
}

export class LoadUsersSuccessAction implements Action {
  readonly type = usersActionTypes.LOAD_SUCCESS;
  constructor(public payload?: User[]) {}
}

export class LoadUsersFailAction implements Action {
  readonly type = usersActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
